import React from "react";
import SearchableCombobox from "@/components/SearchableCombobox";

/**
 * Searchable product picker for invoice line-items.
 *
 * Dedupes by SKU (`product_id` → `sku` → lowercased name), newest-updated_at
 * wins so the most-recent MRP/HSN flows through to the invoice. Search covers
 * name, product_id and HSN.
 *
 * This is a thin wrapper around `SearchableCombobox` — the public API
 * (products/value/onPick/testId/placeholder) is preserved for backwards
 * compatibility with `InvoiceBuilder`.
 */
export default function ProductCombobox({
  products = [],
  value = "",
  onPick,
  testId = "product-combobox",
  placeholder = "Search product…",
}) {
  return (
    <SearchableCombobox
      options={products}
      value={value}
      onPick={onPick}
      testId={testId}
      placeholder={placeholder}
      emptyLabel="No matching products."
      getId={(p) => p.id}
      getKey={(p) =>
        String(
          p.product_id || p.sku || `name:${(p.name || "").toLowerCase()}`
        ).trim()
      }
      getLabel={(p) => p.name || ""}
      getSecondary={(p) =>
        `${p.product_id || p.sku || "—"} · ₹${Number(p.mrp || 0).toLocaleString("en-IN")}`
      }
      getSearchFields={(p) => [p.name, p.product_id, p.hsn]}
    />
  );
}
